var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "wrapper row no-margin",
      staticStyle: { height: "100%", display: "flow-root" }
    },
    [
      _c("header", { staticClass: "row align-items-center no-margin" }, [
        _c("div", { staticClass: "col" }, [
          _c(
            "button",
            {
              staticClass: "btn no-bg",
              on: {
                click: function($event) {
                  return _vm.setPosSection("choose-product")
                }
              }
            },
            [_c("i", { staticClass: "fas fa-times" })]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-12 mt-3 mb-1 status" }, [
        _vm._v(
          "\n    " +
            _vm._s(_vm.$t("apps.pos.message.queuelist")) +
            " (" +
            _vm._s(_vm.queues.length) +
            ")\n  "
        )
      ]),
      _vm._v(" "),
      _c(
        "ul",
        { staticClass: "col-12 no-padding items" },
        _vm._l(_vm.mapQueues, function(queue, index) {
          return _c(
            "li",
            {
              key: index,
              staticClass: "row no-margin item",
              on: {
                click: function($event) {
                  return _vm.onSelectedQueue(queue.queue_number)
                }
              }
            },
            [
              _c("div", { staticClass: "col" }, [
                _c("span", { staticClass: "mr-1" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.$t("apps.pos.message.queuenumber", {
                          number: queue.queue_number
                        })
                      ) +
                      "\n        "
                  )
                ]),
                _vm._v(" "),
                _vm.isRenderTime
                  ? _c(
                      "span",
                      {
                        staticClass: "badge badge-secondary",
                        staticStyle: { position: "relative", top: "-1px" }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.getDiffTime(queue.start_at, {
                                hours: _vm.$t("message.hours"),
                                minutes: _vm.$t("message.minutes"),
                                seconds: _vm.$t("message.seconds")
                              })
                            ) +
                            "\n        "
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isRenderTime && queue.expire_time_mins
                  ? _c(
                      "span",
                      {
                        staticClass: "badge badge-secondary",
                        staticStyle: { position: "relative", top: "-1px" }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$t("apps.pos.message.qrcodetimeleft", {
                                number: queue.expire_time_mins
                              })
                            ) +
                            "\n        "
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                queue.table_number
                  ? _c(
                      "span",
                      {
                        staticClass: "badge badge-secondary",
                        staticStyle: { position: "relative", top: "-1px" }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$t("message.tablename", {
                                ref_name: _vm.refName,
                                number: queue.table_number
                              })
                            ) +
                            "\n        "
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                queue.orderCount
                  ? _c(
                      "span",
                      {
                        staticClass: "badge badge-secondary",
                        staticStyle: { position: "relative", top: "-1px" }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$t("apps.pos.message.orderinqueuecount", {
                                number: queue.orderCount
                              })
                            ) +
                            "\n        "
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                queue.dining_name
                  ? _c(
                      "span",
                      {
                        staticClass: "badge badge-secondary",
                        staticStyle: { position: "relative", top: "-1px" }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.getDiningText(queue.dining_name)) +
                            "\n        "
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                queue.customer_id
                  ? _c(
                      "span",
                      {
                        staticClass: "badge badge-secondary",
                        staticStyle: { position: "relative", top: "-1px" }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.getCustomerName(queue.customer_id)) +
                            "\n        "
                        )
                      ]
                    )
                  : _vm._e()
              ])
            ]
          )
        }),
        0
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-548fceb2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-548fceb2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/pos/sale/main/include/QueueList.vue
// module id = null
// module chunks = 